declare namespace $ {

	type $bog_theme_auto__themes_bog_merchquarium_app_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $bog_favicon__Icon_bog_merchquarium_app_2 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['ico'] >
		,
		ReturnType< $bog_favicon['Icon'] >
	>
	type $mol_hotkey2__action_bog_merchquarium_app_3 = $mol_type_enforce<
		({ 
			ctrl_Z( next?: ReturnType< $bog_merchquarium_app['undo_last'] > ): ReturnType< $bog_merchquarium_app['undo_last'] >,
		}) 
		,
		ReturnType< $mol_hotkey2['action'] >
	>
	type $mol_view__style_bog_merchquarium_app_4 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['avatar_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__attr_bog_merchquarium_app_5 = $mol_type_enforce<
		({ 
			'bog_merchquarium_app_avatar_empty': ReturnType< $bog_merchquarium_app['avatar_empty'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_paragraph__title_bog_merchquarium_app_6 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_merchquarium_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_merchquarium_app_9 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['socials'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_app_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_app_11 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['hero_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_merchquarium_button__title_bog_merchquarium_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_button['title'] >
	>
	type $bog_merchquarium_button__click_bog_merchquarium_app_13 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['product_add'] >
		,
		ReturnType< $bog_merchquarium_button['click'] >
	>
	type $bog_merchquarium_button__hidden_bog_merchquarium_app_14 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['not_editing'] >
		,
		ReturnType< $bog_merchquarium_button['hidden'] >
	>
	type $mol_check_icon__hint_bog_merchquarium_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_bog_merchquarium_app_16 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['Help_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_merchquarium_app_17 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['help_checked'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__hint_bog_merchquarium_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_bog_merchquarium_app_19 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['Preview_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_merchquarium_app_20 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['preview'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_view__sub_bog_merchquarium_app_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_merchquarium_app_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_merchquarium_app_23 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['cart_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_app_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_theme_toggle__theme_auto_bog_merchquarium_app_25 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['Theme_auto'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $mol_button_minor__hint_bog_merchquarium_app_26 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['settings_button_title'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_merchquarium_app_27 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['settings_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_app_28 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['settings_button_sub'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_merchquarium_start__create_bog_merchquarium_app_29 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['catalog_create'] >
		,
		ReturnType< $bog_merchquarium_start['create'] >
	>
	type $mol_button_minor__title_bog_merchquarium_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_app_31 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['product_all'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_select__dictionary_bog_merchquarium_app_32 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['kind_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_merchquarium_app_33 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['category_filter'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_bog_merchquarium_app_34 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['fandom_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_merchquarium_app_35 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['fandom_filter'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_check_box__title_bog_merchquarium_app_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_merchquarium_app_37 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['in_stock_only'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_search__query_bog_merchquarium_app_38 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['search'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_view__sub_bog_merchquarium_app_39 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['filters'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_merchquarium_gallery__items_bog_merchquarium_app_40 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['product_cards'] >
		,
		ReturnType< $bog_merchquarium_gallery['items'] >
	>
	type $mol_paragraph__title_bog_merchquarium_app_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_merchquarium_app_42 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['catalog_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_merchquarium_help__settings_bog_merchquarium_app_43 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['help_settings'] >
		,
		ReturnType< $bog_merchquarium_help['settings'] >
	>
	type $bog_merchquarium_settings__catalog_link_bog_merchquarium_app_44 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['catalog_link'] >
		,
		ReturnType< $bog_merchquarium_settings['catalog_link'] >
	>
	type $bog_merchquarium_cart__catalog_link_bog_merchquarium_app_45 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['catalog_link'] >
		,
		ReturnType< $bog_merchquarium_cart['catalog_link'] >
	>
	type $bog_merchquarium_cart__items_bog_merchquarium_app_46 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['cart'] >
		,
		ReturnType< $bog_merchquarium_cart['items'] >
	>
	type $bog_merchquarium_cart__back_bog_merchquarium_app_47 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['cart_close'] >
		,
		ReturnType< $bog_merchquarium_cart['back'] >
	>
	type $bog_merchquarium_cart__catalog_link_bog_merchquarium_app_48 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['catalog_link'] >
		,
		ReturnType< $bog_merchquarium_cart['catalog_link'] >
	>
	type $bog_merchquarium_cart__items_bog_merchquarium_app_49 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['order_items'] >
		,
		ReturnType< $bog_merchquarium_cart['items'] >
	>
	type $bog_merchquarium_cart__editable_bog_merchquarium_app_50 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_merchquarium_cart['editable'] >
	>
	type $bog_merchquarium_cart__back_bog_merchquarium_app_51 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['cart_close'] >
		,
		ReturnType< $bog_merchquarium_cart['back'] >
	>
	type $bog_merchquarium_product_card__product_link_bog_merchquarium_app_52 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['product_link'] >
		,
		ReturnType< $bog_merchquarium_product_card['product_link'] >
	>
	type $bog_merchquarium_product_card__catalog_link_bog_merchquarium_app_53 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['catalog_link'] >
		,
		ReturnType< $bog_merchquarium_product_card['catalog_link'] >
	>
	type $bog_merchquarium_product_card__search_bog_merchquarium_app_54 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['search'] >
		,
		ReturnType< $bog_merchquarium_product_card['search'] >
	>
	type $bog_merchquarium_product_card__cart_count_bog_merchquarium_app_55 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['cart_count'] >
		,
		ReturnType< $bog_merchquarium_product_card['cart_count'] >
	>
	type $bog_merchquarium_product_card__product_delete_bog_merchquarium_app_56 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['product_delete'] >
		,
		ReturnType< $bog_merchquarium_product_card['product_delete'] >
	>
	type $bog_merchquarium_product_card__editable_bog_merchquarium_app_57 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['editing'] >
		,
		ReturnType< $bog_merchquarium_product_card['editable'] >
	>
	type $mol_link__uri_bog_merchquarium_app_58 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['social_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_merchquarium_app_59 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__hint_bog_merchquarium_app_60 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['social_uri'] >
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__sub_bog_merchquarium_app_61 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['social_sub'] >
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_button_major__title_bog_merchquarium_app_62 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_app_63 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_app['product_undo'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	export class $bog_merchquarium_app extends $mol_page {
		product_link( id: any): string
		catalog_link( ): string
		search( next?: string ): string
		cart_count( id: any, next?: number ): number
		product_delete( id: any, next?: any ): any
		editing( ): boolean
		social_uri( id: any): string
		social_sub( id: any): readonly(any)[]
		product_undo( id: any, next?: any ): any
		Theme_auto( ): $bog_theme_auto
		ico( ): $mol_icon_all_inclusive
		Ico( ): $bog_favicon
		undo_last( next?: any ): any
		Undo_hotkey( ): $mol_hotkey2
		avatar_style( ): Record<string, any>
		avatar_empty( ): boolean
		Avatar( ): $mol_view
		Nick( ): $mol_paragraph
		Profile( ): $mol_view
		Socials_label( ): $mol_paragraph
		socials( ): readonly(any)[]
		Socials_list( ): $mol_view
		Socials( ): $mol_view
		hero_sub( ): readonly(any)[]
		Hero( ): $mol_view
		product_add( next?: any ): any
		not_editing( ): boolean
		Product_add( ): $bog_merchquarium_button
		Help_icon( ): $mol_icon_help_circle_outline
		help_checked( next?: boolean ): boolean
		Help_button( ): $mol_check_icon
		Preview_icon( ): $mol_icon_eye_outline
		preview( next?: boolean ): boolean
		Preview( ): $mol_check_icon
		cart_toggle( next?: any ): any
		Cart_icon( ): $mol_icon_basket
		cart_size_text( ): string
		Cart_size( ): $mol_view
		Cart_button( ): $mol_button_minor
		Lights( ): $bog_theme_toggle
		settings_button_title( ): string
		settings_toggle( next?: any ): any
		Settings_icon( ): $mol_icon_cog
		Return_icon( ): $mol_icon_arrow_left
		settings_button_sub( ): readonly(any)[]
		Settings_button( ): $mol_button_minor
		catalog_create( next?: any ): any
		Catalog_missing( ): $bog_merchquarium_start
		product_all( next?: any ): any
		Product_all( ): $mol_button_minor
		kind_options( ): Record<string, any>
		category_filter( next?: string ): string
		Kind_filter( ): $mol_select
		fandom_options( ): Record<string, any>
		fandom_filter( next?: string ): string
		Fandom_filter( ): $mol_select
		in_stock_only( next?: boolean ): boolean
		In_stock( ): $mol_check_box
		Search( ): $mol_search
		filters( ): readonly(any)[]
		Filters( ): $mol_view
		product_cards( ): readonly(any)[]
		Product_cards( ): $bog_merchquarium_gallery
		Catalog_empty( ): $mol_paragraph
		catalog_rows( ): readonly(any)[]
		Catalog_selected( ): $mol_list
		help_settings( next?: any ): any
		Help( ): $bog_merchquarium_help
		Settings( ): $bog_merchquarium_settings
		cart( next?: Record<string, any> ): Record<string, any>
		cart_close( next?: any ): any
		Cart( ): $bog_merchquarium_cart
		order_items( ): Record<string, any>
		Order( ): $bog_merchquarium_cart
		content( ): readonly(any)[]
		Settings_title( ): string
		Return_title( ): string
		Kind_all( ): string
		Fandom_all( ): string
		title( ): string
		seo_server( ): string
		Product_card( id: any): $bog_merchquarium_product_card
		Social( id: any): $mol_link
		Icon_telegram( id: any): $mol_icon_telegram
		Icon_vk( id: any): $mol_icon_vk
		Icon_youtube( id: any): $mol_icon_youtube
		Icon_instagram( id: any): $mol_icon_instagram
		Icon_web( id: any): $mol_icon_web
		Product_undo( id: any): $mol_button_major
		plugins( ): readonly(any)[]
		head( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): ReturnType< $bog_merchquarium_app['content'] >
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map